module.exports = __webpack_public_path__ + "img/stc_logo.e869fc12.png";